// actions.js

export const setCartItems = (items) => {
    return {
        type: "SET_CART_ITEMS",
        items: items,
    };
};

export const clearCartItems = () => {
    return {
        type: "CLEAR_CART_ITEMS",
    };
};

export const addNewToCart = (item) => {
    return {
        type: "ADD_NEW_TO_CART",
        item: item,
    };
};

export const openCart = () => {
    return {
        type: "OPEN_CART",
    };
};

export const closeCart = () => {
    return {
        type: "CLOSE_CART",
    };
};

export const incrementCartItem = (productId) => {
    return {
        type: "INCREMENT_CART_ITEM_QUANTITY",
        productId: productId,
    };
};

export const decrementCartItem = (productId) => {
    return {
        type: "DECREMENT_CART_ITEM_QUANTITY",
        productId: productId,
    };
};

export const setNumberOfCart = (numberStaffCart) => {
    return {
        type: "SET_NUMBER_OF_STAFF_CART",
        numberStaffCart: numberStaffCart
    }
}

export const setSelectCart = (selectedCart) => {
    return {
        type: "SET_SELECT_CART",
        selectedCart: selectedCart
    }
}